import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from 'react-router-dom';
import { apiCall } from "../utils/apiService";
const ImageNotFound = '/assets/images/image-not-found.jpeg'
let baseURL = "fsadf";
const ScanInstance = () => {
    const [data, setData] = useState([]);
    let intervalId;
    const navigate = useNavigate();
    const [qrcode, setQrcode] = useState(null);
    const [name, setName] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [spinner, setSpinner] = useState(false);
    const [isNewInstance, setIsNewInstance] = useState(false);
    const [selectedInstance, setSelectedInstance] = useState('');
    const [delay, setDelay] = useState(0);
    const [instances, setInstances] = useState([]);
    const [setting, setSetting] = useState({
        isAddQueueLog: false,
    });

    const handleSumbit = async (e) => {
        e.preventDefault(); // Prevent default form submission
        setSpinner(true);
        generateQrcode();
    }

    const generateQrcode = async () => {
        try {
            // Get token from local storage
            const instanceLimit = Number(localStorage.getItem('instanceLimit'));
            const instanceTotal = Number(localStorage.getItem('instanceTotal'));
            if (instanceTotal >= instanceLimit && isNewInstance) {
                setAlertMessage({ message: "You have reached the limit of instances", class: 'danger' });
                hideAlert(10);
                setSpinner(false);
                return;
            }

            const token = localStorage.getItem('token');
            let id;
            if (selectedInstance == '' || isNewInstance) {
                const uid = localStorage.getItem('uid');
                const dataFromat = {
                    id: uid,
                    client_id: name
                };

                // Convert the object to a JSON string
                const jsonString = JSON.stringify(dataFromat);
                const base64String = btoa(jsonString);
                id = base64String;
            } else {
                id = selectedInstance
            }

            const data = await apiCall({
                url: `sessions/add`,
                method: 'Post',
                body: { id, isLegacy: true, name, isNewInstance: isNewInstance, delay },
            });
            setData(data);

            if (data.success) {
                // Update state with fetched user data
                setQrcode(data.data.qr);
                setAlertMessage({ message: 'Scan Qrcode and wait, client is getting ready!', class: 'success' });
                intervalId = setInterval(() => {
                    checkAvailability(token, id);
                }, 10000);
            } else {
                setAlertMessage({ message: data.msg ?? data.message, class: 'danger' });
            }
            setSpinner(false);


        } catch (error) {
            console.error('Error fetching qrcode data:', error);
        }
    };

    const fetchInstances = async () => {
        try {
            const data = await apiCall({
                url: `sessions/get-users-instances?is_list_instance=true`,
                method: 'GET',
            });
            if (data.data.length > 0) {
                localStorage.setItem('instanceTotal', data.data.length);
                // Update state with fetched user data
                setInstances(data.data);
            } else {
                setIsNewInstance(true);
                localStorage.setItem('instanceTotal', 0);
            }
        } catch (error) {
            console.error('Error fetching dashboard:', error);
        }
    };


    const checkAvailability = async (token, id) => {
        try {
            const data = await apiCall({
                url: `sessions/status/${id}`,
                method: 'GET',
            });

            // Parse response data as JSON
            if (data.success) {
                clearInterval(intervalId);
                hideAlert();
                setTimeout(() => {
                    navigate('/instances')

                }, 2000);
            } else {
                setAlertMessage({ message: 'Waiting for qr scanning, please scan qrcode!', class: 'danger' });
            }
        } catch (error) {
            console.error('Error check availiability data:', error);
        }
    };

    // handle to selected template
    const handleSelectInstance = (event) => {
        var instance = instances.find((instance) => instance.client_id == event.target.value)
        setName(instance.name)
        setSelectedInstance(event.target.value);
    };

    const hideAlert = () => {
        setTimeout(() => {
            setAlertMessage('');
        }, 3000);
    }

    useEffect(() => {
        fetchInstances();
        document.title = "Scan Instance";

        const user = JSON.parse(localStorage.getItem('user'))
        setSetting({
            isAddQueueLog: user.isAddQueueLog
        })
    }, []);


    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>

                {/* Breadcrumb */}
                <Breadcrumb title="Scan Instance" />

                <div className="card">
                    <div className="card-body p-md-5">
                        <div className="row">
                            <div className="col-lg-9 col-md-8 col-sm-7 col-12 text-dark order-md-1 order-2">
                                <h5>Log into Your Whatsapp</h5>
                                <p>Message privately with friends and family using WhatsApp on your browser.</p>
                                <ul className="mt-4" >
                                    <li className="my-4 py-4">1. Open WhatsApp on your phone</li>
                                    <li className="my-4 py-4 d-flex align-items-center">2. Tap Menu <Icon icon="tabler:dots-vertical" /> on Android, or Settings <Icon icon="carbon:settings" className="mx-2 rounded border" />  on iPhone</li>
                                    <li className="my-4 py-4">3. Tap Linked devices and then Link a device</li>
                                    <li className="my-4 py-4">4. Point your phone at this screen to scan the QR code</li>
                                </ul>
                                <a href="https://faq.whatsapp.com/1317564962315842/?cms_platform=web&lang=en" style={{ borderBottom: '2px solid green', marginTop: '25px' }} target="_blank">Need Help getting started?</a>
                            </div>
                            <div className="col-lg-3 col-md-4 col-sm-5 col-12 p-0 order-md-2 order-1">
                                <div className={`alert alert-${alertMessage.class} py-1`}>{alertMessage.message}</div>
                                <div className="border">
                                    <img src={qrcode ? qrcode : ImageNotFound} style={{ height: '250px', width: '100%' }} alt={qrcode ? 'QR Code' : 'Image Not Found'} />
                                    <form onSubmit={handleSumbit} className="mt-4 pt-4">
                                        {
                                            instances.length > 0 && (
                                                <div className="d-flex align-items-center px-3">
                                                    <div className="form-switch switch-success d-flex align-items-center gap-3 my-3">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            role="switch"
                                                            id="switch4"
                                                            defaultChecked={true}
                                                            checked={isNewInstance}
                                                            onChange={(e) => setIsNewInstance(!isNewInstance)}
                                                        />
                                                        <label
                                                            className="form-check-label line-height-1 fw-medium text-secondary-light"
                                                            htmlFor="switch4"
                                                        >
                                                            Is New Instance?
                                                        </label>
                                                    </div>
                                                </div>

                                            )
                                        }
                                        {
                                            (isNewInstance || instances.length == 0) && (
                                                <>
                                                    <div className='mb-3 px-3'>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="exampleFormControlInput1"
                                                            placeholder="Type instance name"
                                                            value={name}
                                                            required
                                                            onChange={(e) => setName(e.target.value)}
                                                        />
                                                    </div>
                                                </>
                                            )
                                        }
                                        {
                                            !isNewInstance && instances.length > 0 && (
                                                <>
                                                    <div className='mb-3 px-3'>
                                                        <select className="form-select" required aria-label="Default select example" value={selectedInstance} onChange={handleSelectInstance}>
                                                            <option selected>Choose Instance</option>
                                                            {instances.map((instance) => (
                                                                <option key={instance.id} value={instance.client_id}>
                                                                    {instance.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </>
                                            )
                                        }
                                        {
                                            setting.isAddQueueLog == true && (
                                                <div className='mb-3 px-3'>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        id="exampleFormControlInput1"
                                                        placeholder="Delay in seconds"
                                                        value={delay}
                                                        required
                                                        onChange={(e) => setDelay(e.target.value)}
                                                    />
                                                </div>
                                            )
                                        }
                                        <div className="col-auto d-flex justify-content-center align-items-center">
                                            <button type="submit" className="btn btn-success mb-3">
                                                {
                                                    spinner ? 'Generating QR...' : 'Generate QR'
                                                }

                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </MasterLayout>
        </>
    );
};

export default ScanInstance;
